import { useMemo } from 'react';
import apiClient from 'src/api/axiosClient';

export enum CompanyPhoneType {
  toll_free = "toll_free",
  _10dlc_local = "10dlc_local",
  _10dlc_hosted = "10dlc_hosted",
}
export interface CompanyPhone {
  id: string;
  number: string;
  type: CompanyPhoneType;
  isDefault: boolean;
  label?: string;
}

export function useCompanyPhoneApi() {
  return useMemo(
    () => ({
      getCompanyPhones: (companyId: string) => {
        return apiClient.get<CompanyPhone[]>(`/companies/${companyId}/phone`);
      },
    }),
    []
  );
}
